import React from 'react';
import {Props} from '@src/components/Form/FormField';
import {IProductModel} from '@src/@interfaces/models/Product/IProductModel';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const StagesField = React.lazy(() => import('@views/products/fields/StagesField'));

export default function StagesLazyField(props: Props<IProductModel>) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <StagesField {...props}/>
    </React.Suspense>;
}
